import styled from "@emotion/styled";
import { Input } from "@mantine/core";

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const InputStyledWrapper = styled(Input.Wrapper)`
  display: flex;
  width: 75%;
  max-width: 520px;
  justify-content: space-between;
  align-items: center;
`;
